import { TableCell, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import IdebEditModal from '../../pages/Escola/IdebEditModal/IdebEditModal';
import { removeIdebById } from '../../store/modules/EscolasActions';
import { IDEB_AVERAGE_DECIMALS_TOTAL } from '../../store/modules/EscolasReducer';
import { openModal } from '../../store/modules/ModalActions';
import { isAuthorizedRequest } from '../../utils/httpResponseHandlers';
import { getElementID } from '../../utils/HTMLUtils';
import DeleteForeverIcon from '../Icons/DeleteForeverIcon';
import EditIcon from '../Icons/EditIcon';
import styles from './IdebItem.scss';
const rootClassName = styles.rootClassName;

class IdebItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
    this.toEdit = this.toEdit.bind(this);
    this.toRemove = this.toRemove.bind(this);
  }

  refreshList() {
    this.props.clearProfessoresPageList();
  }

  toEdit() {
    this.props.openModal(IdebEditModal, {
      idEscola: this.props.match.params.id,
      id: this.props.ideb.id,
      savedCallback: this.props.savedCallback,
    });
  }

  changeLoadingStatus(loading, moreProps) {
    if (loading !== this.state.loading) {
      this.setState({
        ...this.state,
        loading: loading,
        ...moreProps,
      });
    }
  }

  toRemove() {
    this.props.removeIdebById(
      this.props.ideb.id,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.sucessDeletarIdeb,
          options: {
            variant: 'success',
          },
        });
        if (typeof this.props.savedCallback === 'function') {
          this.props.savedCallback();
        }
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          this.changeRemovingStatus(false);
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorDeletarIdeb,
            options: {
              variant: 'error',
            },
          });
        } else {
          this.changeSearchingStatus(false, {
            authorizedRequest: false,
          });
        }
      }
    );
  }

  allowEditButton() {
    return this.props.auth.userPermissions.escolas.ideb.edit ? true : false;
  }

  allowRemoveButton() {
    return this.props.auth.userPermissions.escolas.ideb.remove ? true : false;
  }

  render() {
    return (
      <TableRow
        id={getElementID(this.props.id, 'row')}
        className={rootClassName + '-periodo-row'}
      >
        <TableCell className={rootClassName + '-cell'}>
          {this.allowEditButton() ? (
            <button
              onClick={this.toEdit}
              id={getElementID(this.props.id, 'edit')}
            >
              <EditIcon />
            </button>
          ) : null}
          {this.allowRemoveButton() ? (
            <button
              onClick={this.toRemove}
              id={getElementID(this.props.id, 'remove')}
            >
              <DeleteForeverIcon />
            </button>
          ) : null}
        </TableCell>
        <TableCell
          className={rootClassName + '-cell ' + rootClassName + '-link-cell'}
        >
          {this.props.ideb.ano}
        </TableCell>
        <TableCell
          className={rootClassName + '-cell ' + rootClassName + '-link-cell'}
        >
          {Number(this.props.ideb.media).toFixed(IDEB_AVERAGE_DECIMALS_TOTAL)}
        </TableCell>
        <TableCell
          className={rootClassName + '-cell ' + rootClassName + '-link-cell'}
        >
          {Number(this.props.ideb.meta).toFixed(IDEB_AVERAGE_DECIMALS_TOTAL)}
        </TableCell>
      </TableRow>
    );
  }
}

IdebItem.propTypes = {
  id: PropTypes.string,
  ideb: PropTypes.object.isRequired,
  savedCallback: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
      removeIdebById,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(IdebItem));
